import * as Phosphor from "@phosphor-icons/react";

export function SubjectIcon({ name, size = 24, weight = "duotone", ...props }) {
  const Icon = Phosphor[name] || Phosphor.BookOpen;
  return <Icon size={size} weight={weight} {...props} />;
}
